import setFilters from 'store/reducer-utils/setFilters'
import { currencyMap } from 'utils/formatMoney'
import prepareChartData from 'utils/prepareChartData'
import { updateObject } from 'utils/updateObject'
import { IS_APP_PRODUCT_GETUNIQ } from 'utils/constants/product'

const initialState = {
  table: {
    loadFailed: false,
    loading: false,
    data: [],
    summary: {},
    pagination: {
      total: 0,
    },
  },
  chart: {
    loadFailed: false,
    loading: true,
    data: [],
    summary: {},
    chartType: 'Line',
    measure: {
      clicks: '',
      impressions: '',
      cost: IS_APP_PRODUCT_GETUNIQ ? currencyMap.rub : '',
      revenue: IS_APP_PRODUCT_GETUNIQ ? currencyMap.rub : '',
    },
    metrics: [
      { id: 'clicks', isActive: true },
      { id: 'impressions', isActive: true },
      { id: 'cost', isActive: true },
      { id: 'revenue', isActive: true, isHidden: true },
    ],
  },
  filters: null,
}

const setLoading = (state, { payload }) =>
  updateObject(state, {
    [payload]: {
      ...state[payload],
      loading: true,
    },
  })

const setStatisticsChart = (state, { payload }) => {
  const { data, summary } = payload
  const preparedChartData = prepareChartData(data, summary)

  return updateObject(state, {
    chart: {
      ...state.chart,
      data: preparedChartData.items,
      summary: preparedChartData.summary,
      loading: false,
      loadFailed: false,
    },
  })
}

const setStatisticsTable = (state, { payload }) =>
  updateObject(state, {
    table: {
      ...state.table,
      ...payload,
      data: [...state.table.data, ...payload.data],
      loading: false,
      loadFailed: false,
    },
  })

const fetchStatisticsFail = (state, { payload }) =>
  updateObject(state, {
    [payload]: {
      ...state[payload],
      loading: false,
      loadFailed: true,
    },
  })

const dropStatisticsTable = (state) =>
  updateObject(state, {
    table: {
      ...initialState.table,
    },
  })

const setStatisticsFilters = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const applyFilters = (state, { payload }) =>
  updateObject(state, { filters: payload })

const toggleMetricHidden = (state, action) =>
  updateObject(state, {
    chart: {
      ...state.chart,
      metrics: [
        ...state.chart.metrics.map((metric) => {
          const { id, isHidden = false } = metric

          if (id === action.payload.id) {
            return { ...metric, isHidden: !isHidden }
          }

          return metric
        }),
      ],
    },
  })

const setChartType = (state, { payload }) =>
  updateObject(state, {
    chart: { ...state.chart, chartType: payload.type },
  })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'STATISTICS/MAIN_FILTERS_APPLY':
      return applyFilters(state, action)
    case 'STATISTICS/SET_FILTER':
      return setStatisticsFilters(state, action)
    case 'STATISTICS/SET_CHART':
      return setStatisticsChart(state, action)
    case 'STATISTICS/SET_TABLE':
      return setStatisticsTable(state, action)
    case 'STATISTICS/FETCH_TABLE_START':
      return setLoading(state, action)
    case 'STATISTICS/FETCH_CHART_START':
      return setLoading(state, action)
    case 'STATISTICS/FETCH_FAIL':
      return fetchStatisticsFail(state, action)
    case 'STATISTICS/DROP_TABLE_DATA':
      return dropStatisticsTable(state, action)
    case 'STATISTICS/TOGGLE_METRIC_HIDDEN':
      return toggleMetricHidden(state, action)
    case 'STATISTICS/SET_CHART_TYPE':
      return setChartType(state, action)
    default:
      return state
  }
}

export default reducer
